module.exports = __webpack_public_path__ + "first-10_ir.jpg?a10d6908ca1378e08ac9207e2493a7a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10_ir.jpg
// module id = 444
// module chunks = 0